import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Container as PropertyBox } from './PropertyBox.style';
import { Container as PropertyPlaceholder } from './PropertyPlaceholder.style';

export const Container = styled.div<{ background?: string }>`
  padding: 30px 0 20px;
  background-color: ${(props) => props.background || props.theme.background};

  @media (${laptopMediumMax}) {
    padding: 30px 0 10px;
    margin: 0;
  }
`;

export const LoadingBox = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  color: ${(props) => props.theme.textDark};
  margin-left: 30px;

  @media (${laptopMediumMax}) {
    margin-left: 15px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
`;

export const Rail = styled.ul`
  display: flex;
  margin-top: 30px;
  padding: 0;
  flex-wrap: wrap;

  ${PropertyBox}, ${PropertyPlaceholder} {
    width: calc((100% - 120px) / 3);
    min-width: 275px;
    margin-right: 30px;
    margin-bottom: 30px;
  }

  ${PropertyBox}:nth-child(3n+1), ${PropertyPlaceholder}:nth-child(3n+1) {
    margin-left: 30px;
  }

  @media (${laptopMediumMax}) {
    overflow-x: scroll;
    flex-wrap: nowrap;

    ${PropertyBox}, ${PropertyPlaceholder} {
      margin-right: 15px;
    }

    ${PropertyBox}:first-child, ${PropertyPlaceholder}:first-child {
      margin-left: 15px;
    }
  }
`;
